import React from 'react'
import PropTypes from 'prop-types'

import BSCSBreadcrumb from '../breadcrumb'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const PageTitle = (props) => {
  return(
    <React.Fragment>
      {!props.no_breadcrumb &&
        <BSCSBreadcrumb
          pathname={props.location.pathname}
          title={props.title}
          replace={props.replace}
        />
      }
      <Row>
        <Col>
          { props.titleLogo &&
            <div className="d-flex flex-row bd-highlight mb-3">
              <div className="p-2 bd-highlight">
                <img
                  src={props.titleLogo}
                  alt={props.titleLogoAlt}
                  style={{
                    width: "120px",
                    minWidth: "90px"
                  }}
                  className="img-fluid"
                />
              </div>
              <div className="p-2 bd-highlight">
                <h1 className="jumbotron-heading" style={{ color: '#212529' }}>
                  <h1 style={{ marginTop: '.5rem' }}>{props.title}</h1>
                </h1>
              </div>
            </div>
          }
          {!props.titleLogo &&
            <h1 style={{ marginTop: '.5rem', marginBottom: '1.5rem' }}>{props.title}</h1>
          }
          <p><em>{props.date}</em></p>
        </Col>
      </Row>
    </React.Fragment>
  )
}

PageTitle.propTypes = {
  no_breadcrumb: PropTypes.bool,
  location: PropTypes.object,
  title: PropTypes.string.isRequired,
  titleLogo: PropTypes.string,
  titleLogoAlt: PropTypes.string,
  date: PropTypes.string,
  replace: PropTypes.string
}

export default PageTitle